import { styled, styles } from 'helpers'
import { Loading as LoadingComponent, Typography } from 'webbook-airways'

const Spinner = ({ style, size = 64 }: any) => (
  <LoadingComponent color="secondary" style={style} thickness={2} size={size} />
)

const LoadingText = ({ children }: any) => (
  <Typography variant="caption" style={{ marginTop: 15 }}>
    {children}
  </Typography>
)

const LoadingContainer = styled('div')(({ container }: any) => ({
  ...(container && {
    minHeight: 300,
    height: '100%',
  }),
  display: 'flex' as const,
  flexDirection: 'column' as const,
  alignItems: 'center' as const,
  justifyContent: 'center' as const,
  ...styles.animations.fadeInUp,
}))

export const Loading = ({ container = true, size, style, children }: any) => (
  <LoadingContainer container={container}>
    <Spinner style={style} size={size} />
    {children && <LoadingText>{children}</LoadingText>}
  </LoadingContainer>
)
